/**
 * The provider behind an AMM protocol slug from yaas-api: "raydium-cpmm" is "Raydium".
 * Picks a row's logo; null for a slug without a pool kind.
 */
export function lpProtocolProvider(protocol: string): string | null {
    const [provider = "", ...kind] = protocol.split("-");
    if (!provider || kind.length === 0) return null;
    return `${provider.charAt(0).toUpperCase()}${provider.slice(1)}`;
}

/**
 * Display name for an AMM protocol slug from yaas-api: "raydium-cpmm" reads "Raydium CPMM".
 * yaas-api's slugs are `<provider>-<pool kind>` and wallet holdings pass Jachin's protocol
 * through unfiltered, so the label is derived rather than looked up: a protocol yaas-api
 * adds reads correctly with no frontend release.
 */
export function lpProtocolLabel(protocol: string): string {
    const provider = lpProtocolProvider(protocol);
    if (provider === null) return protocol;
    return `${provider} ${protocol.split("-").slice(1).join(" ").toUpperCase()}`;
}
